module.exports = __webpack_public_path__ + "img/bg.c191828f.png";